// extracted by mini-css-extract-plugin
export var addButton = "_mi-0";
export var border = "_mi-8";
export var check = "_mi-h";
export var danger = "_mi-6";
export var dropdownContainer = "_mi-1";
export var editModalBody = "_mi-j";
export var footerContainer = "_mi-i";
export var fullWidth = "_mi-a";
export var hide = "_mi-9";
export var icon = "_mi-3";
export var input = "_mi-7";
export var inputFlex = "_mi-b";
export var inputWrapper = "_mi-c";
export var manualFocus = "_mi-5";
export var optionButton = "_mi-4";
export var pillWrapper = "_mi-e";
export var pointer = "_mi-2";
export var showOverflow = "_mi-f";
export var tagsFlex = "_mi-d";
export var xButton = "_mi-g";